import { Configuration, PopupRequest } from '@azure/msal-browser';
import { environment } from '../../environments/environment';

const isIE =
  globalThis.navigator.userAgent.includes('MSIE ') ||
  globalThis.navigator.userAgent.includes('Trident/');

const { clientId, tenantId, scopes } = environment.auth.azure;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: globalThis.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: isIE,
  },
};

export const loginRequest: PopupRequest = {
  scopes,
  prompt: 'login',
};
